// Set on <html> to RELEASE the lock -- deliberately inverted, so the
// locked state is the plain default that needs no attribute at all.
export const SPARTAN_ENGINE_SCROLL_RELEASED_ATTRIBUTE =
  'data-spartan-engine-scroll-released';

// Inlined into the document, NOT shipped in a stylesheet -- a <link> can
// arrive well after first paint on a slow connection or a low-end device,
// and that gap is exactly what this exists to close. Being locked by
// default also means there is no window at all where the page is painted
// but not yet held: the rule applies the instant the parser reaches it.
export const SPARTAN_ENGINE_SCROLL_LOCK_CSS = `
html { scrollbar-gutter: stable; }
/* This page already reserves the scrollbar gutter. Overlay compensation
   would reserve it twice and resize the paused WebGPU canvas. */
@supports (scrollbar-gutter: stable) {
  html.scroll-locked body,
  html.scroll-locked [data-overlay='opened'] {
    padding-right: 0;
  }
}
html:not([${SPARTAN_ENGINE_SCROLL_RELEASED_ATTRIBUTE}]),
html:not([${SPARTAN_ENGINE_SCROLL_RELEASED_ATTRIBUTE}]) body {
  overflow: hidden;
  overscroll-behavior: none;
}
`;

// Rendered inside <noscript>, so it applies only when scripting is off.
// Without it, a locked-by-default page would be permanently unscrollable
// for those visitors, since the release above can only ever come from a
// React effect. !important because it has to beat the rule above
// regardless of source order.
export const SPARTAN_ENGINE_SCROLL_LOCK_NOSCRIPT_CSS = `
html, html body {
  overflow: visible !important;
  overscroll-behavior: auto !important;
}
`;
